
import { useL10n } from "@ews/react-localization-context";
import { IonButton, IonIcon, IonItem, IonLabel, IonSelect, IonSelectOption } from "@ionic/react";
import { move, trash } from "ionicons/icons";
import { LatLng, Icon as Licon } from "leaflet";
import React, { useEffect } from "react";
import { Marker, Tooltip as MarkerTooltip, Popup } from 'react-leaflet';
import { useNamedRoutes } from "../../../NamedRoutes";
import { usePersistentState } from "../../../Persistence";
import SettingsTextInput from "../../../Settings/SettingsComponents/SettingsTextInput/SettingsTextInput";
import { getIconScaleSize } from "../Element/Element";
import { fontFamilies, fontWeights } from "../Element/types";
import style from "./PlanButton.module.scss";
import { PlanButtonProps } from "./types";

const defaultFontSize = 6;
const defaultIconSize = 24;
const defaultButtonWidth = 100;
const defaultButtonHeight = 30;

export function getScaleSize(originSize: number, zoom: number = 0,)
{
    let result = Math.pow(2, zoom) * originSize;
    return result;
}


export const PlanButton: React.FC<PlanButtonProps> = ({
    plan,
    zoom,
    onChange,
    onDelete,
    eventName = "no-event"
}) =>
{
    const { router, generate } = useNamedRoutes();

    const { translate: t } = useL10n();
    const { systemId: id, label, labelPositionX, labelPositionY, id: planId } = plan;
    const link = generate("system:plan", { id, planId });
    const [planEdit] = usePersistentState<boolean>("authorizationLevelPlan");

    const scale = getScaleSize(plan.style?.height || defaultIconSize, zoom || 0);
    const iconSize = getIconScaleSize(scale, 1);

    const icon = new Licon({
        className: planEdit ? style.moveBtn : "",
        iconUrl: planEdit ? move : "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=",
        iconSize: planEdit ? [iconSize, iconSize] : [0, 0]
    });


    useEffect(() =>
    {
        if (plan && !plan.style) {
            plan.style = {};
        }
    }, [plan]);

    return <>
        <Marker
            interactive={true}

            eventHandlers={{
                click: () =>
                {
                    if (!planEdit) {
                        router?.push(link);
                    }
                },
                dragend: (e) =>
                {
                    const position: LatLng = (e.target as any).getLatLng();
                    plan.labelPositionX = position.lat;
                    plan.labelPositionY = position.lng;

                    if (onChange) onChange(plan, { ...plan });

                }
            }}
            draggable={planEdit}
            position={[labelPositionX!, labelPositionY!]}
            icon={icon}
        >
            {

                <MarkerTooltip
                    interactive
                    direction="left"
                    offset={[0, 0]}
                    permanent
                    className={`${style.tooltip}`}
                    eventHandlers={{
                        dragend: (e) =>
                        {
                            const position: LatLng = (e.target as any).getLatLng();
                            plan.labelPositionX = position.lat;
                            plan.labelPositionY = position.lng;

                            onChange && onChange(plan, { ...plan });
                        }
                    }}

                >
                    {planEdit ? <Popup>
                        <section className={style.popover}>
                            <SettingsTextInput
                                text={"COM_BANNERS_FIELD_WIDTH_LABEL"}
                                endText=":"
                                inputType="number"
                                value={`${plan.style?.width || defaultButtonWidth}`}
                                onChange={(value) =>
                                {
                                    const width = Number(value);
                                    if (width <= 0) return;

                                    plan.style!.width = width;

                                }}
                            />
                            <SettingsTextInput
                                text={"COM_BANNERS_FIELD_HEIGHT_LABEL"}
                                endText=":"
                                inputType="number"
                                value={`${plan.style?.height || defaultButtonHeight}`}
                                onChange={(value) =>
                                {
                                    const height = Number(value);
                                    if (height <= 0) return;

                                    plan.style!.height = height;


                                }}
                            />
                            <IonItem lines="full">
                                <IonSelect
                                    value={plan.style?.fontFamily}
                                    interface="popover"
                                    label={t("[REACT_FONT_FAMILY]")}
                                    //style={{ fontFamily: fontStyle?.fontFamily }}
                                    onIonChange={({ detail }) =>
                                    {
                                        if (!detail.value || !plan.style) return;
                                        plan.style.fontFamily = detail.value;
                                    }
                                    }
                                >
                                    {fontFamilies.map(font =>
                                        <IonSelectOption
                                            //className={style[font.class]}
                                            key={font.class}
                                            value={font.class}
                                        >
                                            {t(font.label as string)}
                                        </IonSelectOption>
                                    )}
                                </IonSelect>
                            </IonItem>

                            <IonItem lines="full">
                                <IonSelect
                                    value={plan.style?.fontWeight}
                                    interface="popover"
                                    label={t("[REACT_FONT_WEIGHT]")}
                                    onIonChange={({ detail }) =>
                                    {
                                        if (!detail.value || !plan.style) return;
                                        plan.style.fontWeight = detail.value;
                                    }
                                    }
                                >
                                    {fontWeights.map(font =>
                                        <IonSelectOption
                                            className={style[font as string]}
                                            key={font}
                                            value={font}
                                        >
                                            {t(font as string)}
                                        </IonSelectOption>
                                    )}
                                </IonSelect>
                            </IonItem>







                            <IonItem>
                                <div
                                    className={style.buttonContainer}
                                >
                                    <IonButton
                                        className={style.saveBtn}
                                        onClick={() =>
                                        {
                                            if (!plan || !plan.style) return;
                                            onChange && onChange(plan, plan || {});
                                        }}
                                        color={"success"}>
                                        <IonLabel>{t("COM_FACPMANAGEMENT_USER_SAVE")}</IonLabel>
                                    </IonButton>

                                    <IonButton
                                        className={style.deleteBtn}
                                        onClick={() =>
                                        {

                                            onDelete && onDelete(plan);
                                        }}
                                        color={"danger"}>
                                        <IonIcon size="medium" icon={trash}></IonIcon>
                                    </IonButton>
                                </div>
                            </IonItem>
                        </section>
                    </Popup> : null}

                    <span
                        className={`${style.btn} ${style[eventName]}`}
                        style={{
                            width: `${getScaleSize(plan?.style?.width || defaultButtonWidth, zoom)}px`,
                            height: `${getScaleSize(plan?.style?.height || defaultButtonHeight, zoom)}px`,
                            borderRadius: `${getScaleSize(plan?.style?.height || defaultButtonHeight, zoom) / 10}px`,
                            marginRight: `${iconSize / 2}px`,
                            fontFamily: `${plan.style?.fontFamily}`,
                            fontWeight: `${plan.style?.fontWeight || "normal"}`,
                            fontSize: `${getScaleSize(plan.style?.height ? (plan.style.height - ((plan.style.height / 100) * 50)) : defaultFontSize, zoom)}px`,
                        }}
                    >
                        <div>
                            {(label)}
                        </div>
                    </span>
                </MarkerTooltip>}
        </Marker >
    </>;
};

export default Element;